<template>
    <div ref="tableWrapper" :id="tableId" style="height: 100%" :class="['table-responsive', 'mt-2', { 'scroll-content': isScrollable}]" :style="isScrollable ? `${height} !important;` : ''">
    <table class="table table-hover" style="table-layout: fixed; font-size: 0.875em;" :style="isScrollable ? 'border-collapse:separate;border-spacing:0;' : ''" >
        <thead style="position: sticky;background-color: white;top: 0px;" :style="isScrollable ? 'z-index:2' : ''">
        <tr ref="tableHeaderRow">
            <th
            v-for="field in fields"
            :key="field.key"
            style="width: 10em;text-align: center;"
            v-if="field.type !== 'daterange'"
            >{{ field.key.slice(0, field.key.length-1) !== 'value' ? $t(field.header) : $t(field.header)}}</th>
            <th
            v-else
            style="width: 23em;text-align: center;"
            >{{ field.key.slice(0, field.key.length-1) !== 'value' ? $t(field.header) : $t(field.header) }}</th>
            <th v-if="isEditable" id="lastColumn" style="width: 9em;"></th>
        </tr>
        </thead>
        <tbody ref="tableBody">
        <!-- Update view -->
        <tr
            v-for="(item, index) in items"
            :key="index"
            @keyup.enter="updateItem(item, fields)"
            @keyup.esc="revertChanges(item)"
            @click="routeTo(item)"
            :class="cursorType"
            ref="tableBodyRow"
        >
            <td v-for="(field, index) in fields" :key="index" :style="field.type === 'link' ? {'text-align': 'center'}: null">
            <div class="tableBodyCell">
                <template v-if="field.type === 'number' || field.type === 'float'">
                <template v-if="field.editable && item.editMode && isEditable">
                    <masked-input
                    v-model="item[field.key].editedValue"
                    :keepCharPositions="false"
                    type="text"
                    :mask="maskOfNumber"
                    :placeholder="$t(field.header)"
                    :class="Object.assign(item[field.key].classes, {'masked-input-custom': true})"
                    @focus="resetWarning(item[field.key])"
                    ></masked-input>
                </template>
                <template
                    v-else-if="item[field.key] && !isNil(item[field.key].value)"
                >{{item | evaluateFormula(field) | parseNumber(field.type, locale)}} {{$t(item[field.key].unit)}}</template>
                <template v-else>{{ item[field.key] ? item[field.key].defaultValue : '-' }}</template>
                </template>
                <template v-else-if="field.type === 'select'">
                <template v-if="field.editable && item.editMode && isEditable">
                    <b-form-select
                    v-model="item[field.key].editedValue"
                    :options="[{value: null, text: $t('choose')}, ...processPaymentMethods()]"
                    style="border-radius: unset !important; height: 100%;"
                    :class="Object.assign(item[field.key].classes, {'form-control-custom': true})"
                    @focus.native="resetWarning(item[field.key])"
                    />
                </template>
                <template v-else>{{ idToPaymentMethod(item[field.key].value) }}</template>
                </template>
                <template v-else-if="field.type === 'date'">
                <template v-if="field.editable && item.editMode && isEditable">
                    <el-date-picker
                    v-model="item[field.key].editedValue"
                    type="date"
                    :readonly="!field.editable"
                    format="dd/MM/yyyy"
                    @focus="resetWarning(item[field.key])"
                    :placeholder="$t('chooseDatePlaceholder')"
                    style="width: 100%"
                    :class="item[field.key].classes"
                    ></el-date-picker>
                </template>
                <template
                    v-else-if="item[field.key] && !isNil(item[field.key].value)"
                >{{item[field.key].value | formatDate('DD/MM/YYYY')}}</template>
                <template v-else>{{ item[field.key] && item[field.key].defaultValue }}</template>
                </template>
                <template v-else-if="field.type === 'identity'&&item.lastModifier&&item.lastModifier">
                <router-link v-if="item.lastModifier.status == 'active'" :to="{name: 'user-profile', params: {user_id: item.lastModifier.id}}">{{item.lastModifier.value}}</router-link>
                <span v-else>{{item.lastModifier.value}}</span>
                </template>
                <template v-else-if="field.type === 'daterange'">
                <template v-if="field.editable && item.editMode && isEditable">
                    <el-date-picker
                    v-model="item[field.key].editedValue"
                    type="daterange"
                    :readonly="!field.editable"
                    format="dd/MM/yyyy"
                    @focus="resetWarning(item[field.key])"
                    :placeholder="$t('chooseDatePlaceholder')"
                    style="width: 100%"
                    :class="item[field.key].classes"
                    />
                </template>
                <template
                    v-else-if="item[field.key] && !isNil(item[field.key].value)"
                >{{item[field.key].value[0] | formatDate('DD/MM/YYYY')}} - {{item[field.key].value[1] | formatDate('DD/MM/YYYY')}}</template>
                <template v-else>{{ item[field.key].defaultValue }}</template>
                </template>
                <!-- In order to add unit of dataType, a new else-if added to here-->
                <template v-else-if="field.type === 'link' && item[field.key] && field.key == 'dataType' ">
                <router-link :to="item.path">{{$t(item[field.key].value) + " (" + $t(item["value"].unit) + ")"}}</router-link>
                </template>
                <template v-else-if="field.type === 'link' && item[field.key]">
                <router-link :to="item.path">{{$t(item[field.key].value)}}</router-link>
                </template>
                <template v-else-if="field.type === 'file'">
                <template v-if="field.editable && item.editMode && isEditable">
                    <div v-if="item[field.key].editedFileId" @click="triggerPopover(item)">
                    <upload
                        :reactiveId="`a_${reactiveId}_${item.id}`"
                        fileCategory="data"
                        :deleteFromDB="true"
                        :dataId="item[field.key].editedId"
                        @ondownload="downloadFile(item[field.key].editedFileUrl ? item[field.key].editedFileUrl : item[field.key].fileUrl)"
                        @onremove="handleRemoving($event, item[field.key])"
                        @onupload="handleUploading($event, item[field.key])"
                    />
                    <b-progress
                        v-show="uploadFiles.length ? uploadFiles[0].active : false"
                        :value="uploadFiles.length ? Number(uploadFiles[0].progress) : 100"
                        variant="secondary"
                        height="0.3em"
                    />
                    </div>
                    <upload-regular 
                    v-else 
                    fileCategory="data" 
                    @onupload="handleUploading($event, item[field.key])"
                    />
                </template>
                <template v-else>
                    <div
                    class="file"
                    v-if="item[field.key].fileId"
                    @click="downloadFile(item[field.key].fileUrl)"
                    >
                    <span>
                        <i class="fas fa-file-alt fa-lg"></i>
                    </span>
                    </div>
                </template>
                </template>
                <template v-else-if="field.type === 'icon'">
                <template
                    v-if=" item[field.key] && (item[field.key].value == null || JSON.parse(item[field.key].value).status === 'health-ok')"
                >
                    <span>
                    <i style="color: #41B884" class="fas fa-check fa-lg"></i>
                    </span>
                </template>
                <template v-else>
                    <template v-if="JSON.parse(item[field.key].value).message == 'not-compared'">
                    <b>-</b>
                    </template>
                    <template v-else-if="item[field.key] && (JSON.parse(item[field.key].value).message && JSON.parse(item[field.key].value).message.length > 0)">
                    <!-- <span v-b-tooltip.hover.right.html="getHealthTooltipMessage(item[field.key].value)"> -->
                        <span style="color:red;font-size:13.7px;">
                            {{getHealthTooltipMessage(item[field.key].value)}}
                        </span>
                    <!--</span>-->
                    </template>
                    <template v-else>
                    <span>
                        <i style="color: #ff0000" class="fas fa-times fa-lg"></i>
                    </span>
                    </template>
                </template>
                </template>
                <!-- Update part of description -->
                <template v-else-if="field.type === 'text'">
                    <template v-if="field.editable && item.editMode && isEditable">
                        <b-form-input
                            id="description"
                            v-model="item[field.key].editedValue"
                            :placeholder="$t(field.header)"
                        />
                    </template>
                    <template v-else>
                        <span v-if="item[field.key].value && item[field.key].value.length > 20" v-b-tooltip.hover.right="$t(item[field.key].value)">
                            <span> 
                                {{$t(item[field.key].value) | shortenText(12)}} 
                            </span>
                        </span>
                        <span v-else>
                                {{$t(item[field.key].value)}}
                        </span>
                    </template>
                </template>
                <template v-else-if="field.type === 'text-translate'">
                    <span v-b-tooltip.hover.right="item[field.key].value">
                        <span> 
                            {{ $t(item[field.key].value) }} 
                        </span>
                    </span>
                </template>
                <template v-else-if="field.type === 'list'">
                    <span v-b-tooltip.hover.right="item[field.key].value">
                        <span> 
                            {{ shortenList(item[field.key].value ,3) }} 
                        </span>
                    </span>
                </template>
                <template v-else-if="field.type === '2-defination'">
                    <span v-b-tooltip.hover.right="item[field.key].value">
                        <span> 
                            {{ item[field.key].value[0] == 'default' ? '' : $t(item[field.key].value[0]) + ' - '}}  {{ $t(item[field.key].value[1]) }} 
                        </span>
                    </span>
                </template>
                <template v-else>
                <template v-if="field.editable && item.editMode && isEditable">
                    <b-form-input
                    v-model="item[field.key].editedValue"
                    :placeholder="$t(field.header)"
                    />
                </template>
                <template v-else>{{item[field.key] ? item[field.key].value : '-'  }}</template>
                </template>
            </div>
            </td>
            <td
            v-if="isEditable"
            :style="{width: lastColumnWidth, 'margin-right': '4px'}"
            class="edit-column"
            >
            <div v-if="tableName != 'data_detail' " class="tableBodyCell"> <!--  v-if="tableName == 'active sources' || tableName == 'inactive sources'" -->
                <div
                @click="sendEmit($event, 'openEditModal', item)" 
                :key="'editspan'"
                style="color: #8888; cursor: pointer"
                >
                <i class="fas fa-edit fa-lg"></i>
                </div>
            </div>
            <div v-else class="tableBodyCell">
                <div
                v-if="!item.editMode"
                @click="makeRowEditable(item)"
                :key="'editspan'"
                style="color: #8888; cursor: pointer"
                >
                <i class="fas fa-edit fa-lg"></i>
                </div>
                <div :key="'btngroup'" v-else class="table-button-group table-cell">
                <b-button v-b-tooltip.hover :title="$t('save')" @click="updateItem(item, fields)" :disabled="item.isSaving">
                    <i class="fas fa-check"></i>
                </b-button>
                <b-button v-b-tooltip.hover :title="$t('cancel')" @click="revertChanges(item)">
                    <i class="fas fa-ban"></i>
                </b-button>
                <b-button v-if="isDeletable"
                    v-b-modal.warn
                    v-b-tooltip.hover
                    :title="$t('delete')"
                    @click="deleteItem($event, item.id)"
                    variant="danger"
                >
                    <i class="fas fa-trash-alt"></i>
                </b-button>
                </div>
            </div>

            </td>
        </tr>
        <!-- Insert view -->
        <transition name="fadere" mode="out-in">
            <tr
            v-if="insertMode"
            @keyup.enter="createItem(tempItem)"
            @keyup.esc="cancelNewRow()"
            style="border-bottom: 1px solid #ddd"
            >
            <td v-for="field in fields">
                <div v-if="field.editable">
                <template v-if="field.type === 'number' || field.type === 'float'">
                    <masked-input
                    v-model="tempItem[field.key].value"
                    :keepCharPositions="false"
                    type="text"
                    :mask="maskOfNumber"
                    :placeholder="$t(field.header)"
                    @focus="resetWarning(tempItem[field.key])"
                    :class="Object.assign(tempItem[field.key].classes, {'masked-input-custom': true})"
                    />
                </template>
                <template v-else-if="field.type === 'select'">
                    <b-form-select
                    v-model="tempItem[field.key].value"
                    :options="[{value: null, text: $t('choose')}, ...processPaymentMethods()]"
                    style="border-radius: unset !important; height: 100%;"
                    :class="Object.assign(tempItem[field.key].classes, {'form-control-custom': true})"
                    @focus.native="resetWarning(tempItem[field.key])"
                    />
                </template>
                <template v-else-if="field.type === 'date'">
                    <el-date-picker
                    :placeholder="$t('chooseDatePlaceholder')"
                    v-model="tempItem[field.key].value"
                    type="date"
                    format="dd/MM/yyyy"
                    style="width: 100%"
                    :class="tempItem[field.key].classes"
                    :default-value="tempItem[field.key].defaultValue"
                    @focus="resetWarning(tempItem[field.key])"
                    />
                </template>
                <template v-else-if="field.type === 'daterange'">
                    <el-date-picker
                    :placeholder="$t('chooseDatePlaceholder')"
                    v-model="tempItem[field.key].value"
                    type="daterange"
                    format="dd/MM/yyyy"
                    style="width: 100%"
                    :class="tempItem[field.key].classes"
                    :default-value="tempItem[field.key].defaultValue"
                    :popperClass="`tempItem[field.key].classes[1] ? 'is-invalid' : ''`"
                    @focus="resetWarning(tempItem[field.key])"
                    />
                </template>
                <template v-else-if="field.type === 'file'">
                    <div v-if="tempItem[field.key].fileId">
                    <upload
                        :reactiveId="`a_${reactiveId}_temp`"
                        fileCategory="data"
                        :deleteFromDB="true"
                        :dataId="tempItem[field.key].id"
                        @ondownload="downloadFile(tempItem[field.key].fileUrl)"
                        @onremove="handleTempRemoving($event, tempItem[field.key])"
                        @onupload="handleTempUploading($event, tempItem[field.key])"
                    />
                    <b-progress
                        v-show="uploadFiles.length ? uploadFiles[0].active : false"
                        :value="uploadFiles.length ? Number(uploadFiles[0].progress) : 100"
                        variant="secondary"
                        height="0.3em"
                    />
                    </div>
                    <upload-regular
                    v-else
                    fileCategory="data"
                    @onupload="handleTempUploading($event, tempItem[field.key])"
                    />
                </template>
                <!-- Insertion part of description -->
                <template v-else-if="field.type === 'text'">
                    <b-form-input
                    v-model="tempItem[field.key].value"
                    :placeholder="$t(field.header)"
                    :class="Object.assign(tempItem[field.key].classes, {'form-control-custom': true})"
                    @focus.native="resetWarning(tempItem[field.key])"
                    />
                </template>
                <template v-else>
                    <b-form-input
                    v-model="tempItem[field.key].value"
                    :placeholder="$t(field.header)"
                    />
                </template>
                </div>
                <!-- Insertion part of datatype choosing -->
                <div v-if="field.type === 'link' && field.key === 'dataType'">
                <!-- Insertion part of datatype choosing 
                <b-form-select
                v-model="tempItem[field.key]"
                :options="getDataTypes()"
                style="border-radius: unset !important; height: 100%;"
                />
                -->
                <b-form-select v-model="tempItem[field.key]" v-bind:ref="'datatypeForm'">
                    <option v-for="dataType in getDataTypes()" v-bind:ref="'datatype'" :value="dataType" :key="dataType.id" >{{ dataType.name + dataType.unit }}</option>
                </b-form-select>
                </div> 
            </td>
            <td
                v-if="isEditable"
                class="edit-column"
                :style="{width: lastColumnWidth, 'margin-right': '4px'}"
            >
                <div class="table-button-group">
                <b-button
                    v-b-tooltip.hover
                    :title="$t('save')"
                    @click="createItem(tempItem)"
                    style="mso-border-shadow: no"
                    :disabled="insertingNewItem"
                >
                    <i class="fas fa-check"></i>
                </b-button>
                <b-button v-b-tooltip.hover :title="$t('cancel')" @click="cancelNewRow()">
                    <i class="fas fa-ban"></i>
                </b-button>
                </div>
            </td>
            </tr>
        </transition>
        </tbody>
        <tfoot class="insert-row" v-if="tableName == 'data_detail'">
        <tr v-if="!insertMode && isEditable" @click="insertRow()" >
            <td :colspan="this.fields.length + 1" style="border: 1px solid #ddd">
            <div class="tableBodyCell">
                <div style="left: 0; bottom: 54px; right: 0; margin:auto">
                <i class="fas fa-plus-circle fa-2x"></i>
                </div>
            </div>
            </td>
        </tr>
        </tfoot>
        
    </table>
    </div>
</template>

<script>
// Table component will be deprecated after CustomTable.vue is being stable.
import _ from 'lodash';
import moment from 'moment';
import uuidV4 from 'uuid/v4';
import Upload from '../components/Upload.vue';
import UploadRegular from '../components/UploadRegular.vue';

export default {
    components: {Upload, UploadRegular},
    name: 'vueTable',
    props: {
        tableName: {
            type: String
        },
        initialData: {
            type: Object,
            default: () => ({
                items: [],
                fields: []
            })
        },
        isEditable: {
            type: Boolean,
            default: () => false
        },
        isScrollable: {
            type: Boolean,
            default: () => true
        },
        height: {
            type: String,
            default: 'height: calc(100vh - 350px)'
        },
        isDeletable: {
            type: Boolean,
            default: () => true
        }
    },
    data() {
        return {
            insertMode: false, // toggles insert mode
            insertingNewItem: false, // Currently insterting flag
            fields: [], // table headers
            items: [], // includes some info to show on cells,
            tempItem: {}, // stores data entered by user
            lastColumnWidth: '140px', // 'em' typed width value to specify action column width
            tableScrollActive: false, // checks if table has scroll bar
            tableFontSize: 0.875,
            tableId: uuidV4(),
            reactiveId: uuidV4(),
            perPage: {
                prev: 0,
                current: 0,
            }
        };
    },

    methods: {
        shortenList(dataList, maxLength){
            if(dataList == undefined || _.isEmpty(dataList)){
                return "-";
            }
            if(dataList.length>3){
                return _.join(dataList.slice(0,maxLength), ",")+this.$t('and')+_.toString(dataList.length-maxLength)+" "+this.$t('more');
            }else{
                return _.join(dataList, ",");
            }
        },

        sendEmit(event, emitName, item){
            return this.$emit(emitName, {id:item.id,name:this.tableName}, event);
        },

        idToPaymentMethod(val) {
            let found = _.find(this.paymentMethods, {value: val});
            return found ? this.$t(found.text) : '';
        },
        
        getHealthTooltipMessage(health) {
            health = JSON.parse(health);
            /* let message = '<table>';
            if (health.message && health.message[0]) {
                message += '<tr style="font-size:12px"><td style="text-align:left;">' + health.message[0] + '</td></tr>';
            }
            if (health.message && health.message[1]) {
                message += '<tr style="font-size:12px"><td style="text-align:left;">' + health.message[1] + '</td></tr>';
            }

            message += '</table>'; */
            // return health.message[0];
            health.message = _.map(health.message, msg => {
                let translate_msg = this.$t(msg.replace(/\s\(.+/, ''));
                return msg.replace(/.+\s/, `${translate_msg} `);
            });
            return health.message.join(', ');
        },
        getDataTypes() {
            let filteredOptions = [];
            let units = [];
            let dataTag =
                _.get(_.find(JSON.parse(localStorage.getItem('tags')), {active: true}), 'key') ||
                'consumption';
            let dataTypes = _.filter(this.$store.state.dataTypes, {type: dataTag});
            // Filter out some data types for customer 1 non-admin users
            if (
                this.gbId(this.$store.state.user.customerId) &&
                !this.$store.state.user.permissions.isAdmin
            ) {
                if (dataTag == 'consumption') {
                    dataTypes = _.filter(
                        dataTypes,
                        dt => dt.unit_id_1 != 3 && !dt.name.match(/ATM/i)
                    );
                } else if (dataTag == 'supplychain') {
                    dataTypes = _.filter(dataTypes, dt =>
                        dt.name.match(/(a4|dekont|uncoated-freesheet|uncoated-groundwood)/i)
                    );
                }
            }
            _.each(dataTypes, dataType => {
                let unit = [];
                filteredOptions.push(dataType);
                unit.name =
                    ' (' +
                    this.$t(_.find(this.$store.state.units, {id: dataType.unit_id_1}).name) +
                    ')';
                unit.id = dataType.id;
                units.push(unit);
            });
            filteredOptions.forEach(dataType => {
                dataType.name = this.$t(dataType.name);
                dataType.unit = _.find(units, {id: dataType.id}).name;
            });
            return filteredOptions;
        },
        isNil(value) {
            return _.isNil(value);
        },
        // Hide warning message
        resetWarning(item) {
            item.classes['is-invalid'] = false;
            item.hasWarn = false;
        },

        // Make a row editable
        makeRowEditable(item) {
            this.items.forEach(this.revertChanges);
            this.insertMode = false;
            item.editMode = true;

            // Focus on first item in row
            return this.$nextTick().then(() => {
                let elements = document.getElementsByClassName('masked-input-custom');
                elements.length
                    ? elements[0].focus()
                    : console.log('There is no element to be focused.');
                return true;
            });
        },

        // Insert a new table row
        insertRow() {
            this.items.forEach(this.revertChanges);
            this.insertingNewItem = false;
            this.insertMode = true;
            this.items.forEach(item => {
                item.isSaving = false;
                item.editMode = false;
            });
            this.bindTempItemToView();
            
            
            // Focus on first item in row
            return this.$nextTick().then(() => {
                let elements = document.getElementsByClassName('masked-input-custom');
                this.tableName == 'data_detail'
                ? elements[0].focus()
                : this.$refs.datatypeForm[0].$el.scrollIntoView({behavior: 'smooth'});
                return true;
            });
        },

        // Cancel newly inserted row
        cancelNewRow() {
            if(_.get(_.get(this.tempItem,'file'),'id') && _.get(_.get(this.tempItem,'file'),'onCloud')){
                return this.axios.delete(`/deleteFromAws/${this.tempItem['file'].id}`)
                    .then(()=>{
                            this.insertMode = false;
                            this.bindTempItemToView();
                        });
            }
            else{
                this.insertMode = false;
                this.bindTempItemToView();
            }
        },

        // Insert new item
        createItem(item) {
            if (this.isInsertValid(item) && !this.insertingNewItem) {
                this.insertingNewItem = true;
                this.$emit('insertItem', item, data => {
                    this.insertMode = false;
                    this.items.push(this.prepareItem(data));
                    this.bindTempItemToView();
                    this.calculateLastColumnWidth();
                    this.insertingNewItem = false;
                }, () => this.insertingNewItem = false);
            }
        },

        // Update existing item
        updateItem(item, fields) {
            if (this.isUpdateValid(item, fields) && !item.isSaving) {
                item.isSaving = true;
                this.$emit('applyDataChanges', item, fields, data => {
                    let updatedItem = this.prepareItem(data);
                    for (let key in item) {
                        item[key] = updatedItem[key];
                    }
                    item.editMode = false;
                    item.isSaving = false;
                }, () => item.isSaving = false);
            }
        },

        // Delete an item
        deleteItem($event, id) {
            this.showWarnModal($event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, () => {
                this.$emit('deleteItemById', id);
                this.items = this.items.filter(item => {
                    return item.id !== id;
                });
            });
        },

        setPaymentMethod(id, item) {
            item.editedValue = id;
        },

        processPaymentMethods() {
            return _.map(this.paymentMethods, v => ({value: v.value, text: this.$t(v.text)}));
        },

        handleUploading(event, item) {
            item.editedId = event.id;
            item.editedFilename = event.filename;
            item.editedFileId = event.fileId;
            item.editedFileUrl = event.fileUrl;
            item.editedOnCloud = event.onCloud;
            this.$store.state.uploadFiles = [];
        },

        handleTempUploading(event, item) {
            item.id = event.id;
            item.filename = event.filename;
            item.fileId = event.fileId;
            item.fileUrl = event.fileUrl;
            item.onCloud = event.onCloud;
        },

        handleRemoving(event, item) {
            item.editedFileId = null;
        },

        handleTempRemoving(event, item) {
            item.fileId = null;
            item.id = null;
        },

        // Revert any changes made on an item
        revertChanges(item) {
            let revertItem = (item)=>{
                this.fields.forEach(field => {
                if (field.editable) {
                        if (field.type === 'date') {
                            item[field.key].editedValue = moment(item[field.key].value).toDate();
                        } else if (field.type === 'daterange') {
                            item[field.key].editedValue = [
                                moment(item[field.key].value[0]).toDate(),
                                moment(item[field.key].value[1]).toDate()
                            ];
                        } else if (field.type === 'number' || field.type === 'text' || field.type === 'list' || field.type === 'text-translate') {
                            item[field.key].editedValue = item[field.key].value;
                        } else if (field.type === 'float') {
                            item[field.key].editedValue = item[field.key].value
                                ? this.convertToLocalizedFloat(item[field.key].value, this.locale)
                                : null;
                        } else if (field.type === 'file') {
                            item[field.key].editedFileId = item[field.key].fileId;
                            item[field.key].editedFileUrl = item[field.key].fileUrl;
                            item[field.key].editedFilename = item[field.key].filename;
                            item[field.key].editedId = item[field.key].id; 
                            item[field.key].editedOnCloud = item[field.key].onCloud; 
                        }
                        item[field.key].classes['is-invalid'] = false;
                        item[field.key].hasWarn = false;
                    }
                });
                item.editMode = false;
            };

            if(_.includes(Object.keys(item), 'file')){
                if(item['file'].editedFileId != item['file'].fileId && item['file'].editedOnCloud){
                    this.axios.delete(`/deleteFromAws/${item['file'].editedId}`)
                        .then(()=>revertItem(item));
                }
                else{
                    revertItem(item);
                }
            }else{
                revertItem(item);
            }
        },

        // Validate newly entered data
        isInsertValid(item) {
            let isValid = true;
            let fileValid = true;
            /* let lastItem = this.items[this.items.length - 1];
            if (item.cost && item.value1 && lastItem) {
                let value = parseFloat(item.value1.value.replace(/\./g, ''));
                let cost = parseFloat(item.cost.value.replace(/\./g, ''));
                let unitPrice = lastItem.cost.value / lastItem.value1.value;
                let insertedUnitPrice = cost / value;
                let minUnitPrice = unitPrice * 70 / 100;
                let maxUnitPrice = unitPrice * 130 / 100;
                if (insertedUnitPrice < minUnitPrice || insertedUnitPrice > maxUnitPrice) {
                    this.$toasted.error(this.$t('unitPriceError'));
                    isValid = false;
                    return isValid;
                }
            } */

            for (let key in item) {
                if (key == "file" && item[key].required && _.isNil(item[key].fileId) && item[key].hasOwnProperty('fileId')) {
                item[key].classes['is-invalid'] = true;
                item[key].hasWarn = true;
                item[key].style = {'width':'100%','border':'1px solid #ff0000'};
                fileValid = false;
                }
                else{
                if (
                    item[key].required &&
                    _.isNil(item[key].value) &&
                    item[key].hasOwnProperty('value')
                ) {
                    item[key].classes['is-invalid'] = true;
                    item[key].hasWarn = true;
                    isValid = false;
                }
                }

                /* if((key == 'file') && (!item[key].fileId && !this.$store.state.user.permissions.canStartAudits)){
                    this.$toasted.error(this.$t('missingBillUpload'));
                    isValid = false;
                    return isValid;
                } */
            }
            if(!fileValid && isValid){
                this.$toasted.error(this.$t('missingFile'));
            }
            else if (!isValid) {
                this.$toasted.error(this.$t('missingError'));
            } else if (
                !item.unit &&
                item.date &&
                item.date.value[1] > new Date(new Date().setHours(0, 0, 0, 0))
            ) {
                item.date.classes['is-invalid'] = true;
                item.date.hasWarn = true;
                isValid = false;
                this.$toasted.error(this.$t('futureDateBill'));
            }
            return (isValid && fileValid);
        },

        // Validate updates to existing data
        isUpdateValid(item, fields) {
            let isValid = true;
            let fileValid = true;

            fields.forEach(field => {
            if(field.key == "file" && field.required && _.isNil(item[field.key].editedFileId) && item[field.key].hasOwnProperty('editedFileId')){
                item[field.key].classes['is-invalid'] = true;
                item[field.key].hasWarn = true;
                item[field.key].style = {'width':'100%','border':'1px solid #ff0000'};
                fileValid = false;
            }
            else if (field.required && field.editable && field.type !== 'file') {
                if (!item[field.key].editedValue) {
                    item[field.key].classes['is-invalid'] = true;
                    item[field.key].hasWarn = true;
                    isValid = false;
                }
            }
            });

            if(!fileValid && isValid){
            this.$toasted.error(this.$t('missingFile'));
            }
            else if (!isValid) {
                this.$toasted.error(this.$t('missingError'));
            } else if (item.date.editedValue[1] > new Date()) {
                item.date.classes['is-invalid'] = true;
                item.date.hasWarn = true;
                isValid = false;
                this.$toasted.error(this.$t('futureDateBill'));
            }
            return (isValid && fileValid);
        },

        // Prepare items in the correct format
        // The property editValue is used to store data entered by user
        prepareItem(data) {
            let row = {...data.cols};
            let generated = {};
            for (let key in row) {
                let foundField = _.find(this.fields, {key: key});
                if (foundField) {
                    generated[key] = row[key];
                    if (this.isEditable) {
                        if (foundField.type === 'daterange') {
                            generated[key].editedValue = [
                                moment(generated[key].value[0]).toDate(),
                                moment(generated[key].value[1]).toDate()
                            ];
                        } else if (foundField.type === 'date') {
                            generated[key].editedValue = moment(generated[key].value).toDate();
                        } else if (foundField.type === 'number' || foundField.type === 'text' || foundField.type === 'text-translate') {
                            generated[key].editedValue = generated[key].value
                                ? generated[key].value
                                : '-';
                        } else if(foundField.type === 'list'){
                        generated[key].editedValue = generated[key].value
                                ? generated[key].value
                                : [];
                        } else if (
                            foundField.type === 'float' &&
                            generated[key] &&
                            generated[key].value
                        ) {
                            generated[key].value = generated[key].value.toFixed(2);
                            generated[key].editedValue = this.convertToLocalizedFloat(
                                generated[key].value,
                                this.locale
                            );
                        } else if (
                            foundField.type === 'link' &&
                            generated[key] &&
                            generated[key].value
                        ) {
                            generated[key].editedValue = generated[key].value;
                        } else if (foundField.type === 'file') {
                            generated[key].onCloud = row[key].fileOnCloud;
                            generated[key].editedOnCloud = generated[key].onCloud;
                            generated[key].fileId = row[key].fileId;
                            generated[key].editedFileId = generated[key].fileId;
                            generated[key].fileUrl = row[key].fileUrl;
                            generated[key].editedFileUrl = generated[key].fileUrl;
                            generated[key].filename = row[key].filename;
                            generated[key].editedFilename = generated[key].filename;
                        } else if (foundField.type === 'select') {
                            generated[key].editedValue = generated[key].value;
                        } else if (foundField.type === 'identity') {
                            generated[key] = row.lastModifier;
                        } else {
                            generated[key].editedValue = generated[key].value
                                ? generated[key].value
                                : '-';
                        }

                        generated[key].classes = {
                            'form-control':
                                foundField.type !== 'date' && foundField.type !== 'daterange',
                            'is-invalid': false
                        };
                        generated[key].hasWarn = false;
                        generated[key].required = foundField.required;
                    }
                }
            }
            generated.isSaving = false;
            generated.editMode = false;
            generated.id = data.id;
            generated.path = data.path;

            return generated;
        },

        setDefaultDateTypedValue(type, key) {
            let defaultVal = null;
            if (this.items.length) {
                if (type === 'date') {
                    let lastItem = this.items[this.items.length - 1];
                    defaultVal = lastItem[key].value;
                } else if (type === 'daterange') {
                    let lastItem = this.items[this.items.length - 1];
                    defaultVal = lastItem[key].value;
                }
            } else {
                if (type === 'date') {
                    defaultVal = this.createUTCDate(this.year, 0, 1);
                } else if (type === 'daterange') {
                    defaultVal = this.createUTCDate(this.year, 0, 1);
                }
            }
            return defaultVal;
        },

        setDefaultSelectTypedValue(key) {
            let defaultVal = null;
            if (this.items.length) {
                let lastItem = this.items[this.items.length - 1];
                defaultVal = lastItem[key].value;
            }
            return defaultVal;
        },

        // Bind temporary item storage to view
        bindTempItemToView() {
            this.tempItem = {};
            this.fields.forEach(field => {
                if (field.editable) {
                    if (field.type === 'file') {
                        this.$set(this.tempItem, field.key, {
                            filename: null,
                            fileUrl: null,
                            fileId: null,
                            onCloud: !(this.isbId(this.$store.state.user.customerId) || this.gbId(this.$store.state.user.customerId)),
                            hasWarn: false,
                            required: field.required,
                            classes: {
                                'form-control': field.type !== 'date' && field.type !== 'daterange',
                                'is-invalid': false
                            },
                        });
                    } else {
                        let defaultValue = null;
                        if (field.type === 'date' || field.type === 'daterange') {
                            defaultValue = this.setDefaultDateTypedValue(field.type, field.key);
                        } else if (field.type === 'select') {
                            defaultValue = this.setDefaultSelectTypedValue(field.key);
                        }
                        this.$set(this.tempItem, field.key, {
                            value: field.type === 'select' ? defaultValue : null,
                            defaultValue,
                            classes: {
                                'form-control': field.type !== 'date' && field.type !== 'daterange',
                                'is-invalid': false
                            },
                            hasWarn: false,
                            required: field.required
                        });
                    }
                }
            });
        },

        // Called on initial render and every data update
        init(items = [], fields = []) {
            this.fields = fields;
            this.items = items.map(this.prepareItem);
            if (this.isEditable) {
                this.bindTempItemToView();
            }
            this.calculateLastColumnWidth();
        },

        calculateLastColumnWidth() {
            return this.$nextTick().then(() => {
                let element = document.getElementById('lastColumn');
                if (element) {
                    this.lastColumnWidth = element.offsetWidth + 'px';
                }
                return true;
            });
        },

        routeTo(item) {
            if (!this.isEditable) {
                this.$router.push({path: item.path});
            }
        },

        triggerPopover(item) {
            document.getElementById(`a_${this.reactiveId}_${item.id}`).focus();
        },

        // Caclulates the count of table items per page by table-wrapper's height. 
        // Emits it if per page changes and per page greater than 2
        calcPerPage() {
            this.perPage.current = Math.floor((this.$refs.tableWrapper.offsetHeight - this.headerRowHeight) / this.bodyRowHeight);

            if(this.perPage.prev !== this.perPage.current && this.perPage.current > 2) {

                this.perPage.prev = this.perPage.current;
                this.$emit("per-page", this.perPage.current);
            }
        }
    },

    computed: {
        headerRowHeight() {
            return this.$refs.tableHeaderRow.offsetHeight;
        },
        bodyRowHeight() {
            return this.$refs.tableBodyRow ? this.$refs.tableBodyRow[0].offsetHeight : 1;
        },
        cursorType() {
            var cursorClass = 'cursor-isEditable';
            if (!this.isEditable) {
                cursorClass = 'cursor-nonEditable';
            }
            return cursorClass;
        }
    },

    watch: {
        initialData: {
            handler(newVal) {
                this.init(_.cloneDeep(newVal.items), _.cloneDeep(newVal.fields));
                
                this.$nextTick(() => {
                    this.calcPerPage();
                });
            },
            deep: true,
        }
    },
    created() {
        window.addEventListener('resize', this.calculateLastColumnWidth);
        this.init(_.cloneDeep(this.initialData.items), _.cloneDeep(this.initialData.fields));

        window.addEventListener("resize", this.calcPerPage);
    },
    beforeDestroy() {
        this.items.forEach(this.revertChanges);
        window.removeEventListener('resize', this.calculateLastColumnWidth);
        window.removeEventListener("resize", this.calcPerPage);
    }
};
</script>

<style lang="scss" scoped>
.fadere-enter-active {
    opacity: 1;
    transition: opacity 0.6s ease;
}

.fadere-enter,
.fadere-leave-to,
.fadere-leave-active {
    opacity: 0;
}

.cursor-isEditable {
    cursor: default;
}

.cursor-nonEditable {
    cursor: pointer;
}

.file {
    cursor: pointer;
    .file-text {
        &:hover {
            text-decoration: underline;
        }
    }
}
.edit-column {
    position: static;
    -webkit-box-shadow: none;
    box-shadow: none;
    border-left: none;
}

.table thead th {
    border: none;
}
.tableBodyCell {
    height: 30px;
}

.scroll-content tfoot,
.scroll-content tfoot th,
.scroll-content tfoot td {
    position: sticky;
    bottom: 0;
    border-bottom-color: #ddd;
    background: white;
    z-index:2;
}

</style>

<i18n src="../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "startDate": "Başlangıç",
            "endDate": "Bitiş",
            "Veri Sağlığı": "Veri Kontrolü",
            "Fatura": "Fatura",
            "Açıklama": "Açıklama",
            "description": "Açıklama",
            "Son Değişiklik Tarihi": "Son Değişiklik",
            "Tarih Aralığı": "Tarih Aralığı",
            "Maliyet": "Tutar",
            "Ödeme Yöntemi": "Ödeme Tipi",
            "Veri Tipi": "Veri Tipi",
            "Son Düzenleyen": "Son Düzenleyen",
            "dataType": "Veri Tipi",
            "value": "Tüketim Miktarı",
            "Miktar": "Tüketim Miktarı",
            "noUnits": "Adet",
            "noUnitsValue": "Toplam Tüketim",
            "noUnitsCost": "Toplam Tutar",
            "Talep": "Talep Miktarı",
            "Low Unit Price": "Düşük Birim Fiyat",
            "High Unit Price": "Yüksek Birim Fiyat",
            "Düşük Birim Fiyat": "Düşük Birim Fiyat",
            "Yüksek Birim Fiyat": "Yüksek Birim Fiyat",
            "Yüksek Tüketim": "Yüksek Tüketim",
            "High Consumption": "Yüksek Tüketim",
            "more": "daha",
            "and": " ve ",
            "Source": "Kaynak",
            "Activity":	"Aktivite",
            "Type":	"Tür",
            "Location":	"Lokasyon",
            "disableYear": "İnaktivasyon Yılı",
            "Veri Sagligi": "Veri Kontrolü",
            "Son Degisiklik Tarihi": "Son Değişiklik",
            "Tarih Araligi": "Tarih Aralığı",
            "Aciklama": "Açıklama"
        },
        "en": {
            "startDate": "Start Date",
            "endDate": "End Date",
            "Veri Sağlığı": "Data Health",
            "Tarih Aralığı": "Date Range",
            "Fatura": "Bill",
            "Açıklama": "Description",
            "description": "Description",
            "Son Değişiklik Tarihi": "Last Update",
            "Maliyet": "Cost",
            "Ödeme Yöntemi": "Payment Method",
            "Veri Tipi": "Data Type",
            "Son Düzenleyen": "Last Editor",
            "dataType": "Data Type",
            "value": "Amount",
            "Miktar": "Amount",
            "Adet": "Unit",
            "Toplam Tüketim": "Total Consumption",
            "Toplam Maliyet": "Total Cost",
            "Talep": "Demand",
            "Low Unit Price": "Low Unit Price",
            "High Unit Price": "High Unit Price",
            "Düşük Birim Fiyat": "Low Unit Price",
            "Yüksek Birim Fiyat": "High Unit Price",
            "Yüksek Tüketim": "High Consumption",
            "High Consumption": "High Consumption",
            "Aylık Ortalama Tüketim": "Monthly Average Consumption",
            "Aylık Ortalama Maliyet": "Monthly Average Cost",
            "more": "more",
            "and": " and ",
            "Source": "Source",
            "Activity":	"Activity",
            "Type":	"Type",
            "Location":	"Location",
            "disableYear": "Inactivation Year",
            "Veri Sagligi": "Data Health",
            "Son Degisiklik Tarihi": "Last Update",
            "Tarih Araligi": "Date Range",
            "Aciklama": "Description"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/components/Table.vue